import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import LotInfoFormLayout from './LotInfoFormLayout';
import { LoadPanel } from 'devextreme-react/load-panel';
import notify from 'devextreme/ui/notify';
import FormField from '../../../../../dynamicFormBuilder/FormField'
import { Button } from 'devextreme-react/button';
import Toolbar, { Item } from "devextreme-react/toolbar";
import { AdditionalLayout, UserDefinedLayout } from "./Layout";

function UserDefinedTab(props) {
    var accessToken = props.oidc.user.access_token;
    const [changedField, setChangedField] = useState(null);
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    var currentUser = props.oidc.user;
    const formRefs = useRef({});
    const handleReset = () => {
        let row=props.selectedDetails;
        
     if(row)
        props.setformFields(prevFields => ({
            ...prevFields,
                ROWID:row.ROWID,
                USERDEFINEDCODE1:row.code1,
                USERDEFINEDCODE2:row.code2,
                USERDEFINEDCODE3:row.code3,
                USERDEFINEDCODE4:row.code4,
                USERDEFINEDCODE5:row.code5,
                USERDEFINEDDATE1:row.date1,
                USERDEFINEDDATE2:row.date2,
                USERDEFINEDDATE3:row.date3,
                USERDEFINEDDATE4:row.date4,
                USERDEFINEDDATE5:row.date5,
                USERDEFINEDQUANTITY1:row.quantity1,
                USERDEFINEDQUANTITY2:row.quantity2,
                USERDEFINEDQUANTITY3:row.quantity3,
                USERDEFINEDQUANTITY4:row.quantity4,
                USERDEFINEDQUANTITY5:row.quantity5,
                USERDEFINEDREFERENCE1:row.reference1,
                USERDEFINEDREFERENCE2:row.reference2,
                USERDEFINEDREFERENCE3:row.reference3,
                USERDEFINEDREFERENCE4:row.reference4,
                USERDEFINEDREFERENCE5:row.reference5,
        }));
    };

    const handleFieldChange = (name, value, e) => {
        
        if(e?.event){
            props.formFields[name] = value;
            props.setformFields(prevFields => ({
                ...prevFields,
                [name]: value,
            }));
            props.handleFormSubmit();
        }
    };
    const handlePrimaryFormLoad = useCallback(() => {
        loadLookupFromStaticData(formRefs, "OVERRIDESHIPDAYS", [{ id: 'Y', name: "Yes" }, { id: 'N', name: "No" }]);
        if(props.isCommittedTransaction){
            if (formRefs.current) {
                Object.keys(formRefs.current).forEach((key) => {
                    //if (key === "REFERENCE" || key === "COMMENT") return;
                    const instance = formRefs.current[key]?.instance;
                    if (instance && typeof instance.option === 'function') {
                        instance.option('disabled', true);
                    }
                });
            }
        }

    }, []);

    const loadLookupFromStaticData = (formRefs, name, dataSource) => {
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', 'id');
            formRefs.current[name].instance().option('displayExpr', 'name');
            if (props.formFields[name])
                formRefs.current[name].instance().option('value', props.formFields[name]);
        }

    };
    useEffect(() => {
        handleReset();
    }, [props.refKey]);
    return (

        <div id="accordion" style={{ height: "100%", overflow: "auto" }}>
                <div className="AccordionItemBody">
                    <FormField
                        currrentUser={currentUser}
                        layoutId='A6AA6C7E-8CEC-4BF9-9B41-862D7E05C9E8'
                        layoutName='WMTransDetailsUserDefinedForm'
                        defaultFormSchema={UserDefinedLayout}
                        formFields={props.formFields}
                        setformFields={props.setformFields}
                        handleFieldValueChange={handleFieldChange}
                        DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                        formRefs={formRefs}
                        onFormLoad={handlePrimaryFormLoad}
                    />
                </div>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(UserDefinedTab);